import { render } from "./EditDistributorModal.vue?vue&type=template&id=26050e92&ts=true"
import script from "./EditDistributorModal.vue?vue&type=script&lang=ts"
export * from "./EditDistributorModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__